module.exports = __webpack_public_path__ + "static/media/ticket.9855879f.png";